import React, { useMemo, useEffect, useState } from 'react'
import Table from './../../components/Table'  // new
import { connect } from 'react-redux'
import { getCellLeadersRequested, updateCellLeaderRequested, addCellLeaderRequested, deleteCellLeaderRequested } from '../../actions/cellLeaderAction'
import { impersonateUserRequested } from '../../actions/impersonateAction'
import Modal from '../../components/Modal';
import { TrashIcon, PlusCircleIcon, UserCircleIcon } from '@heroicons/react/outline'
import { UsersIcon, UserGroupIcon } from '@heroicons/react/solid'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';

const Users = ({
    cellLeaderGetRequested,
    cellLeader,
    cellLeaders,
    getCellLeadersRequested: getCellLeaders,
    updateCellLeaderRequested: updateCellLeader,
    deleteCellLeaderRequested: deleteLeader,
    addCellLeaderRequested: addCellLeader,
    impersonateUserRequested: impersonateUser
}) => {
    // const [cellLeaders, setCellLeaders] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);
    // const [error, setError] = React.useState(null);
    const [edit, setEdit] = React.useState(false);
    // const [loading, setLoading] = React.useState(false);
    const [formData, setFormData] = React.useState({});
    const [isInitialRender, setIsInitialRender] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        console.log("Cell Leaders", cellLeaders);
        getCellLeaders()
    }, []);

    const columns = useMemo(() => [
        {
            Header: "#",
            Cell: ({ cell }) => (
                <div className="flex items-center space-x-2">
                    <p>{cell.row.index + 1}</p>
                </div>
            ),
        },
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: "Email",
            accessor: 'email',
        },
        {
            Header: "Username",
            accessor: 'username',
        },
        {
            Header: "Action",
            accessor: 'id',
            idAccessor: 'id',
            Cell: ({ cell, row, column }) => (
                <div className="flex items-center space-x-1">
                    <button
                        className="px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm bg-blue-100 text-blue-800"
                        onClick={() => {
                            impersonateUser(row.original[column.idAccessor]);
                            navigate('/dashboard/');
                        }}
                    >
                        Act As
                    </button>
                    <button
                        className="px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm bg-yellow-100 text-yellow-800"
                        onClick={() => handleEdit(cell.row.original)}
                    >
                        Edit
                    </button>
                    <button
                        className="px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm bg-red-100 text-red-800"
                        onClick={() => handleDeleteUser(row.original[column.idAccessor])}
                    >
                        <TrashIcon className="h-5 w-5" />
                    </button>
                </div>
            ),
        },
    ], []);

    const handleEdit = (data) => {
        console.log(data);
        setEdit(true);
        setFormData(data);
        setShowModal(true);
    };

    const handleDeleteUser = (id) => {
        console.log("Delete Report", id);
        deleteLeader(id);
    };

    const handleAddCellLeader = () => {
        console.log("Add cell leader");
        addCellLeader(formData);
        setShowModal(false);
    }

    const handleOpenModal = () => {
        console.log("Add cell leader");
        setShowModal(true);
    };

    const handleCloseModal = (e) => {
        e.preventDefault();
        setFormData({});
        setShowModal(false);
        setEdit(false);
    };

    const handleEditLeader = (e) => {
        e.preventDefault();
        console.log("Edit Cell Leader");
        console.log(formData);
        updateCellLeader(formData);
        // setCellLeaders([...cellLeaders]);
        setFormData({});
        setShowModal(false);
        setEdit(false);
    };

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormData(values => ({ ...values, [name]: value }))
    }

    // Calculate stats
    const totalLeaders = cellLeaders.length;
    const leadersWithEmail = cellLeaders.filter(l => l.email).length;

    return (
        <div className="min-h-screen bg-gray-100 text-gray-900">
            <Modal title={edit ? "Edit cell leader" : "Add cell leader"} onClose={handleCloseModal} show={showModal} data={formData} onSubmit={edit && edit ? handleEditLeader : handleAddCellLeader}>
                <form className='space-y-6'>
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">Name</label>
                        <div className="mt-2">
                            <input
                                id="name"
                                name="name"
                                type="text"
                                autoComplete="cell name"
                                required
                                className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                value={formData?.name || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">Email</label>
                        <div className="mt-2">
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="enter email"
                                required
                                className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                value={formData?.email || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">Username</label>
                        <div className="mt-2">
                            <input
                                id="username"
                                name="username"
                                type="text"
                                autoComplete='false'
                                required
                                className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                value={formData?.username || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                </form>
            </Modal>
            <main className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* Header */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">Cell Leaders</h1>
                        <p className="text-gray-500 mt-1">Manage your cell group leaders</p>
                    </div>
                    <button
                        onClick={() => handleOpenModal()}
                        className="flex flex-row items-center gap-2 bg-emerald-500 text-white hover:bg-emerald-600 active:bg-emerald-700 font-semibold px-4 py-2 rounded-lg shadow-md transition-all duration-150"
                        type="button"
                    >
                        <PlusCircleIcon className="h-5 w-5" />
                        Add Cell Leader
                    </button>
                </div>

                {/* Stats Cards */}
                {cellLeaders.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                        <StatCard
                            title="Total Cell Leaders"
                            value={totalLeaders}
                            icon={<UsersIcon className="h-6 w-6 text-white" />}
                            bgColor="bg-emerald-500"
                        />
                        <StatCard
                            title="With Email"
                            value={leadersWithEmail}
                            icon={<UserGroupIcon className="h-6 w-6 text-white" />}
                            bgColor="bg-blue-500"
                        />
                    </div>
                )}

                {/* Table */}
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    {cellLeaders.length > 0 ? (
                        <div className="overflow-x-auto">
                            <Table columns={columns} data={cellLeaders} />
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-16">
                            <UserCircleIcon className="h-16 w-16 text-gray-300 mb-4" />
                            <h2 className="text-xl font-semibold text-gray-700">No cell leaders found</h2>
                            <p className="text-gray-500 mt-1">Get started by adding a new cell leader</p>
                            <button
                                onClick={() => handleOpenModal()}
                                className="mt-4 flex items-center gap-2 bg-emerald-500 text-white hover:bg-emerald-600 font-medium px-4 py-2 rounded-lg transition-colors"
                            >
                                <PlusCircleIcon className="h-5 w-5" />
                                Add Your First Cell Leader
                            </button>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}

// Stat Card Component
const StatCard = ({ title, value, icon, bgColor }) => {
    return (
        <div className="bg-white shadow-lg rounded-lg p-6">
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-gray-600 text-sm font-medium mb-1">{title}</p>
                    <p className="text-3xl font-bold text-gray-900">{value}</p>
                </div>
                <div className={`${bgColor} rounded-full p-3`}>
                    {icon}
                </div>
            </div>
        </div>
    );
};

Users.propTypes = {
    error: PropTypes.string,
    cellLeader: PropTypes.object,
    cellLeaders: PropTypes.array,
    getCellLeadersRequested: PropTypes.func.isRequired,
    cellLeaderGetRequested: PropTypes.bool.isRequired,
};

Users.defaultProps = {
    error: '',
    cellLeaders: [],
    cellLeaderGetRequested: false,
};

const mapStateToProps = (state) => ({
    error: state.auth.loginError,
    cellLeader: state.cellLeader.cellLeader,
    cellLeaders: state.cellLeader.cellLeaders
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getCellLeadersRequested,
    updateCellLeaderRequested,
    addCellLeaderRequested,
    deleteCellLeaderRequested,
    impersonateUserRequested,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Users);